import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import type { Period } from "@/api/admin/economics";

const OPTIONS: Period[] = ["last_7d", "last_30d", "last_90d"];

const rowStyle: CSSProperties = { display: "flex", gap: 8, flexWrap: "wrap" };

function chipStyle(active: boolean): CSSProperties {
  return {
    height: 32,
    padding: "0 14px",
    borderRadius: 999,
    border: active ? "1px solid var(--d-violet)" : "1px solid var(--d-line)",
    background: active ? "rgba(107,79,232,0.18)" : "transparent",
    color: active ? "var(--d-fg)" : "var(--d-fg-muted)",
    fontFamily: "var(--font-body)",
    fontSize: 13,
    cursor: "pointer",
    transition: "background .15s ease, border-color .15s ease",
  };
}

export function PeriodPicker(): JSX.Element {
  const { t } = useTranslation("admin");
  const [params, setParams] = useSearchParams();
  const current = (params.get("period") as Period) ?? "last_30d";

  function setPeriod(p: Period) {
    const next = new URLSearchParams(params);
    next.set("period", p);
    setParams(next, { replace: true });
  }

  return (
    <div style={rowStyle} role="radiogroup" aria-label={t("economics.title")}>
      {OPTIONS.map((p) => (
        <button
          key={p}
          type="button"
          role="radio"
          aria-checked={current === p}
          style={chipStyle(current === p)}
          onClick={() => setPeriod(p)}
        >
          {t(`economics.period.${p}`)}
        </button>
      ))}
    </div>
  );
}
